export default __webpack_public_path__ + "static/media/trash-blue-xl.ee8477f9.svg";